export type Language = {
  language: string;
  level: number;
};

export type ExtractedData = {
  name?: string;
  birthYear?: number;
  email?: string;
  phone?: string;
  position?: string;
  level?: string;
  yearsOfExperience?: number;
  managementExperience?: number;
  languages?: Language[];
  preferredLocation?: string;
  experience?: string[];
  education?: string[];
  skills?: string[];
  missingFields: string[];
};

export type ManualFormData = {
  name: string;
  birthYear: number;
  email: string;
  phone: string;
  position: string;
  level: string;
  yearsOfExperience: number;
  managementExperience: number;
  languages: string;
  languageLevels: string;
  preferredLocation: string;
  skills: string;
};

export type UploadStatus = {
  isUploading: boolean;
  uploadProgress: number;
  isProcessing: boolean;
};

export type CVUploadState = {
  isPopupOpen: boolean;
  file: File | null;
  previewUrl: string | null;
  activeTab: string;
  dragActive: boolean;
  isManualEntry: boolean;
  manualData: ManualFormData;
  extractedData: ExtractedData | null;
  uploadStatus: UploadStatus;
}; 

export const CV_UPLOAD_OPTIONS = {
  languages: [
    { value: "English", label: "English" },
    { value: "Vietnamese", label: "Vietnamese" },
    { value: "Japanese", label: "Japanese" },
  ],
  skills: [
    { value: "React", label: "React" },
    { value: "JavaScript", label: "JavaScript" },
    { value: "TypeScript", label: "TypeScript" },
    { value: "Node.js", label: "Node.js" },
    { value: "Python", label: "Python" },
    { value: "Java", label: "Java" },
    { value: "C#", label: "C#" },
    { value: "AWS", label: "AWS" },
    { value: "Docker", label: "Docker" },
    { value: "Kubernetes", label: "Kubernetes" },
    { value: "SQL", label: "SQL" },
    { value: "NoSQL", label: "NoSQL" },
    { value: "Git", label: "Git" },
    { value: "CI/CD", label: "CI/CD" },
    { value: "Agile", label: "Agile" },
    { value: "Scrum", label: "Scrum" },
    { value: "Shopify", label: "Shopify" },
    { value: "Liquid", label: "Liquid" },
    { value: "Shopify Apps", label: "Shopify Apps" },
    { value: "Shopify Themes", label: "Shopify Themes" },
    { value: "Shopify Plus", label: "Shopify Plus" },
    { value: "Shopify API", label: "Shopify API" },
    { value: "Ecommerce", label: "Ecommerce" },
    { value: "WooCommerce", label: "WooCommerce" },
    { value: "Magento", label: "Magento" },
    { value: "BigCommerce", label: "BigCommerce" },
    { value: "Headless Commerce", label: "Headless Commerce" },
    { value: "Payment Gateways", label: "Payment Gateways" },
    { value: "Stripe", label: "Stripe" },
    { value: "PayPal", label: "PayPal" },
  ],
  locations: [
    { value: "HN", label: "HN" },
    { value: "HCM", label: "HCM" },
    { value: "Remote", label: "Remote" },
  ],
  positions: [
    { value: "Frontend Developer", label: "Frontend Developer" },
    { value: "Backend Developer", label: "Backend Developer" },
    { value: "Fullstack Developer", label: "Fullstack Developer" },
    { value: "DevOps Engineer", label: "DevOps Engineer" },
    { value: "Data Scientist", label: "Data Scientist" },
    { value: "UX/UI Designer", label: "UX/UI Designer" },
    { value: "Product Manager", label: "Product Manager" },
    { value: "Project Manager", label: "Project Manager" },
    { value: "QA Engineer", label: "QA Engineer" },
    { value: "QA Automation Engineer", label: "QA Automation Engineer" },
    { value: "QA Manual Engineer", label: "QA Manual Engineer" },
    { value: "QA Manager", label: "QA Manager" },
    { value: "QA Lead", label: "QA Lead" },
    { value: "QA Specialist", label: "QA Specialist" },
    { value: "Scrum Master", label: "Scrum Master" },
    { value: "Business Analyst", label: "Business Analyst" },
    { value: "HRBP", label: "HRBP" },
    { value: "HR Manager", label: "HR Manager" },
    { value: "HR Specialist", label: "HR Specialist" },
    { value: "HR Coordinator", label: "HR Coordinator" },
    { value: "HR Generalist", label: "HR Generalist" },
    { value: "HR Administrator", label: "HR Administrator" },
    { value: "Sales", label: "Sales" },
    { value: "Sales Manager", label: "Sales Manager" },
    { value: "Sales Representative", label: "Sales Representative" },
    { value: "Sales Coordinator", label: "Sales Coordinator" },
    { value: "Sales Specialist", label: "Sales Specialist" },
    { value: "Sales Administrator", label: "Sales Administrator" },
    { value: "Shopify Developer", label: "Shopify Developer" },
    { value: "Shopify Designer", label: "Shopify Designer" },
    { value: "Shopify Analyst", label: "Shopify Analyst" },
    { value: "Shopify Manager", label: "Shopify Manager" },
    { value: "Shopify Specialist", label: "Shopify Specialist" },
    { value: "Shopify Administrator", label: "Shopify Administrator" },
  ]
};